import React from "react";
import { profile } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="relative border-t border-[#1f1a15] py-10 overflow-hidden">
      {/* Marquee */}
      <div className="relative whitespace-nowrap overflow-hidden">
        <div className="marquee-track flex gap-10 text-[13vw] leading-none text-[#1a1410] select-none"
             style={{ fontFamily: "'Instrument Serif', serif" }}>
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={i} className="inline-flex items-center gap-8">
              {profile.brand}
              <span className="text-[#f5b14e]/20">✦</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] mono text-[#f2ece1]/50">
        <div>
          © {new Date().getFullYear()} {profile.name} — All reels reserved.
        </div>
        <div className="flex items-center gap-4">
          <span>PAL/NTSC</span>
          <span>•</span>
          <span>RECORDED IN {profile.location.toUpperCase()}</span>
          <span>•</span>
          <span>v1.0</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
